/**
 * Vue Mixin for color utilities
 * Provides computed properties and methods for using dynamic colors in components
 */

import { getButtonColorStyle, getLighterBackground, mixHexColors } from './colorUtils';

export const colorMixin = {
  computed: {
    primaryColor() {
      const color = this.$store.state.colorPrincipal || "#2f4f4f";
      // Validar se é um hex válido (3 ou 6 dígitos)
      if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color)) {
        return color;
      }
      return "#2f4f4f";
    }
  },

  methods: {
    /**
     * Get dynamic button styles
     * @param {string} state - 'normal', 'hover', 'active'
     * @returns {object} - CSS style object
     */
    getPrimaryButtonStyle(state = 'normal') {
      return getButtonColorStyle(this.primaryColor, state);
    },

    /**
     * Get lighter background color (for cards, sections, etc.)
     * @param {number} opacity - Opacity level (0-1)
     * @returns {string} - RGBA color string
     */
    getPrimaryBackground(opacity = 0.1) {
      return getLighterBackground(this.primaryColor, opacity);
    },

    /**
     * Mix primary color with another color
     * @param {string} targetColor - Target color in hex
     * @param {number} amount - Mix ratio (0-1)
     * @returns {string} - Mixed color in hex
     */
    mixPrimaryColor(targetColor, amount) {
      return mixHexColors(this.primaryColor, targetColor, amount);
    },

    /**
     * Get inline style for primary color as text or background
     * @param {string} type - 'text' or 'background'
     * @returns {object} - Style object
     */
    getPrimaryColorStyle(type = 'text') {
      if (type === 'text') {
        return { color: this.primaryColor };
      }
      return { backgroundColor: this.primaryColor };
    }
  }
};

export default colorMixin;
